import React from "react";
import { useTranslation } from "react-i18next";
import ChecklistExportModal from "../ChecklistExportModal";
import { ExportsTable } from "@weezevent/gofast-front";
import PropTypes from "prop-types";

const getChecklists = item =>
	item.data.checkpoint_id
		? [item.data.checkpoint_id]
		: item.data.checkpoints_id;

const ChecklistExport = ({ filters }) => {
	const { t } = useTranslation();
	const exportFilters = { ...filters, ordering: "-created" };
	const [
		checklistDetailsModalData,
		setChecklistDetailsModalData
	] = React.useState(null);
	return (
		<>
			<ExportsTable
				queryParams={exportFilters}
				columns={[
					{
						label: t(
							"access.checkpoint.exportTab.tableRows.numberOfChecklists"
						),
						key: "checklists",
						render: item => getChecklists(item)?.length
					}
				]}
				getActions={item => [
					{
						action: () => {
							setChecklistDetailsModalData(getChecklists(item));
						},
						label: t(
							"access.checkpoint.exportTab.actions.detailsChecklistsInfo"
						)
					}
				]}
			/>
			<ChecklistExportModal
				onClose={() => setChecklistDetailsModalData(null)}
				open={!!checklistDetailsModalData}
				checkListIds={checklistDetailsModalData}
			/>
		</>
	);
};
ChecklistExport.propTypes = {
	filters: PropTypes.object
};
ChecklistExport.defaultProps = {
	filters: {}
};

export default ChecklistExport;
